export const blockIconsCommunicationHourglassTopNew = (
	<span className='material-symbols-outlined'>hourglass_top</span>
);
